export default __webpack_public_path__ + "static/media/list_milita_2.1467771c.png";